module.exports = __webpack_public_path__ + "media/מ.c3e6357a.mp3";